// src/components/WeeklyOutcome.js
import React, { useEffect, useState, useCallback } from "react";
import { saveWeeklyOutcome, getWeeklyOutcome } from "./localStorageUtils";

const WeeklyOutcome = ({
  tasks,
  mode, // Now received from Dashboard.js
  triggerStrobe = () => {},
  onOutcomeChange = () => {},
}) => {
  const [outcome, setOutcome] = useState({ mode: "neutral", streak: 0 });
  const [message, setMessage] = useState("");

  // Define divine blessing messages for each mode.
  const blessingMessages = {
    momentum: [
      "You moved with strength. I redirected your luck to open doors.",
      "Your productivity lit the path; luck transformed into breakthroughs.",
    ],
    stabilization: [
      "You allowed yourself to rest. I used your luck to shield you from storms.",
      "In stillness, I guarded your path—luck kept chaos at bay.",
    ],
  };

  // Update outcome when mode changes.
  const updateOutcome = useCallback(
    (newMode) => {
      setOutcome((prev) => {
        const newStreak = prev.mode === newMode ? prev.streak + 1 : 1;
        const newOutcome = { mode: newMode, streak: newStreak };
        onOutcomeChange(newMode, newStreak);
        saveWeeklyOutcome(newOutcome)
          .then(() => console.log("Weekly outcome saved:", newOutcome))
          .catch((err) => console.error("Failed to save weekly outcome:", err));
        return newOutcome;
      });
      // Select a divine blessing message.
      const msgs = blessingMessages[newMode];
      const randomIndex = Math.floor(Math.random() * msgs.length);
      setMessage(msgs[randomIndex]);
      triggerStrobe();
    },
    [onOutcomeChange, triggerStrobe, blessingMessages]
  );

  // Load the initial outcome on mount.
  useEffect(() => {
    getWeeklyOutcome()
      .then((initialOutcome) => {
        if (initialOutcome && initialOutcome.mode && initialOutcome.mode !== outcome.mode) {
          setOutcome(initialOutcome);
          onOutcomeChange(initialOutcome.mode, initialOutcome.streak);
        }
      })
      .catch((err) => console.error("Failed to load weekly outcome:", err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // When the mode prop changes and tasks exist, update outcome.
  useEffect(() => {
    if (tasks.length > 0 && mode !== outcome.mode) {
      updateOutcome(mode);
    }
  }, [tasks, mode, outcome.mode, updateOutcome]);

  // Select a background style based on mode.
  const backgroundStyle =
    mode === "momentum"
      ? "bg-gradient-to-r from-purple-500 to-yellow-500"
      : "bg-gradient-to-r from-blue-500 to-green-500";

  return (
    <div className={`weekly-outcome mt-6 mb-8 p-6 rounded-lg shadow-xl ${backgroundStyle} transition-all duration-700`}>
      <h2 className="text-2xl font-bold text-center text-white">
        {outcome.mode.charAt(0).toUpperCase() + outcome.mode.slice(1)} Mode (Streak: {outcome.streak})
      </h2>
      {message && <p className="text-center italic text-white mt-4">{message}</p>}
    </div>
  );
};

export default WeeklyOutcome;
